import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod'
import { HttpClient } from '@angular/common/http';
import { languages } from 'src/app/models/languages'
import { BehaviorSubject, Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Firestore, doc, docData } from '@angular/fire/firestore';


@Injectable({
  providedIn: 'root'
})
export class LanguagesService {

  languages = languages;

  private firestore = inject(Firestore);

  // BehaviorSubject ენის ცვლილებისათვის
  private selectedLanguageSource = new BehaviorSubject<any>(this.getInitialLanguage());
  selectedLanguage$ = this.selectedLanguageSource.asObservable(); // Observable, რომელზეც კომპონენტები რეაგირებენ


  // კატეგორიის ან პროდუქტის დამატების ენის BehaviorSubject (ახალი დამატება)
 private productCategoryLanguageSource =
  new BehaviorSubject<string>('');

productCategoryLanguage$ =
  this.productCategoryLanguageSource.asObservable();


  constructor(private http: HttpClient) {}

  // ინიციალიზაცია localStorage-დან
  getInitialLanguage(): any {
    const savedLanguage = localStorage.getItem('selectedLanguageObject');
    return savedLanguage ? JSON.parse(savedLanguage) : this.languages.find(lang => lang.default);
  }

  // ენის კოდის მიხედვით ძებნა
  getLanguageByCode(code: string): any {
    // console.log('Languages array:', this.languages); // მასივის ლოგირება
    return this.languages.find(language => {
      // console.log('Checking language:', language.code, 'against', code); // შედარების ლოგირება
      return language.code === code;
    });
  }

  // არჩეული ენის ამოღება (დაამატეთ ეს მეთოდი)
  getSelectedLanguage(): any {
    const savedLanguage = localStorage.getItem('selectedLanguageObject');
    if (savedLanguage) {
      return JSON.parse(savedLanguage);
    }
    return this.getInitialLanguage();
  }

  // ენის ცვლილების ფუნქცია
  setSelectedLanguage(code: string): void {
    const selectedLanguage = this.getLanguageByCode(code);
    // console.log('არჩეული ენა', selectedLanguage)
    if (selectedLanguage) {
      localStorage.setItem('selectedLanguageObject', JSON.stringify(selectedLanguage));
      this.selectedLanguageSource.next(selectedLanguage); // ენის განახლება და სუბიექტისთვის შეტყობინება
    }
  }


  // მომხმარებლის
  // ამოღება active ენების სერვერიდან
  getActiveLanguages(id: number): any {
    return this.http.get(`${environment.apiUrl}app/languages/${id}`);
  }

  // firebace-დან გამოტანა ენების
  // getUserLanguages(userId: string, appId: string): Observable<any> {
  //   // ეს გამოიტანს დოკუმენტის ყველა ველს, მათ შორის languages
  //   return this.firestore.doc(`Users/${userId}/Apps/${appId}`).valueChanges({ idField: 'id' });
  // }
  getUserLanguages(userId: string, appId: string): Observable<any> {
    const docRef = doc(this.firestore, `Users/${userId}/Apps/${appId}`);
    return docData(docRef, { idField: 'id' });
  }


  // productCategoryLanguageSource-ის განახლება localStorage-ის გარეშე
  setProductCategoryLanguageSource(
  languageCode: string
): void {

  if (!languageCode) {
    return;
  }

  this.productCategoryLanguageSource.next(
    languageCode
  );
}

clearProductCategoryLanguage(): void {
  this.productCategoryLanguageSource.next('');
}

  
  
}